import e from"react";import r from"./Loader.less.js";var o=function(o){var a=o.size,t=void 0===a?"medium":a,c="".concat(r.loader," ").concat(t&&r["loader-".concat(t)]);return e.createElement("div",{className:c})};export{o as Loader};
//# sourceMappingURL=Loader.js.map
